import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getClientRequestHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    // Get logged-in user ID from localStorage
    const userData = localStorage.getItem("User");
    let userId = "";
    if (userData) {
      try {
        const parsed = JSON.parse(userData);
        userId = parsed._id || parsed.id || parsed.userId || "";
      } catch (e) {
        console.log("Error parsing userData:", e);
      }
    }
    
    console.log("API HIT - User ID:", userId);
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: "clients_request", options: `userId=${userId}`, ...action.payload }),
    );
    yield put({
      type: types.GET_CLIENT_REQUEST_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.GET_CLIENT_REQUEST_ERROR,
      payload,
    });
  }
}

export function* getClientRequestWatcherSaga() {
  yield takeLatest(types.GET_CLIENT_REQUEST_START, getClientRequestHandlerSaga);
}

//delete

function* deleteClientRequestHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.delete,
      endPoint.deleteDyanamicItem("clients_request", action.payload),
    );
    yield put({
      type: types.DELETE_CLIENT_REQUEST_SUCCESS,
      payload: data,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.DELETE_CLIENT_REQUEST_ERROR,
      payload,
    });
  }
}

export function* deleteClientRequestWatcherSaga() {
  yield takeLatest(types.DELETE_CLIENT_REQUEST_START, deleteClientRequestHandlerSaga);
}

//single item

function* getSingleClientRequestHandlerSaga(action) {
  const apiClient = apiClientFactory();
  try {
    const { data } = yield call(
      apiClient.get,
      endPoint.dynamicList({ path: `clients_request/${action.payload}` }),
    );
    console.log("API HIT")
    yield put({
      type: types.SINGLE_CLIENT_REQUEST_SUCCESS,
      payload: data.response,
    });
  } catch (e) {
    const payload = e?.response?.data || e;
    yield put({
      type: types.SINGLE_CLIENT_REQUEST_ERROR,
      payload,
    });
  }
}

export function* getSingleClientRequestWatcherSaga() {
  yield takeLatest(types.SINGLE_CLIENT_REQUEST_START, getSingleClientRequestHandlerSaga);
}

